export const invalidIdsErrorMsg = 'Failed to process batch because of Invalid IDs.';

export const failedToSendErrorMsg = 'Batch processed but some upmids or emails failed to send.';

/**
 * Returns an error message based on the properties of the provided result object.
 * LOGIC BASED ON INVARIANT: we only receive either invalidIds or failedToSend, not both
 *
 * @param result - An object potentially containing invalid IDs, failed sends, or other errors.
 * @param result.invalidIds - An optional array of invalid IDs.
 * @param result.failedToSend - An optional array of items that failed to send.
 * @param result.errors - An optional array of error messages.
 * @returns A descriptive error message or an empty string if no error condition is met.
 */
export const getErrorMessage = (result: { 
    invalidIds?: string[], 
    failedToSend?: string[], 
    errors?: string[] 
  }): string => result?.invalidIds?.length ? invalidIdsErrorMsg
    : result?.failedToSend?.length ? failedToSendErrorMsg : '';

/**
 * Retrieves a comma-separated list of invalid IDs or emails from the provided result object.
 *
 * @param result - An object that may contain arrays of invalid IDs or emails that failed to send.
 * @returns A string containing any invalid IDs or failed emails, or an empty string if none exist.
 */
export const getErroneousIdsOrEmails = (result: { 
    invalidIds?: string[], 
    failedToSend?: string[] 
  }): string => result?.invalidIds?.join(', ') || result?.failedToSend?.join(', ') || '';